import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CTX = createContext(null);
const STORAGE_KEY = 'root_informatica_theme';

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'; }
    catch { return 'light'; }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(t => t === 'light' ? 'dark' : 'light');
  }, []);

  return <CTX.Provider value={{ theme, toggleTheme, isDark: theme === 'dark' }}>{children}</CTX.Provider>;
}

export function useTheme() {
  const ctx = useContext(CTX);
  if (!ctx) throw new Error('useTheme debe usarse dentro de ThemeProvider');
  return ctx;
}
